// import React from 'react';

// function Images({
//   ImagesContent,
//   LanguageSelected,
//   t,
//   currentIndex,
//   setCurrentIndex,
//   ImageUrl,
//   hashedUserId,
//   goToPrev,
//   goToNext
//   , divstyle,
//   img5
// }) {
//   const getText=(textObj)=>{
//     if(!textObj)return '';
//     if(typeof textObj==='object' && textObj!==null){
//       return textObj[LanguageSelected] || '';
//     }
//     return textObj || '';
//   };

//   const hasValidContent=(image)=>{
//     const title=getText(image.title);
//     const subtitle=getText(image.subtitle);
//     return title.trim() !=='' || subtitle.trim() !=='';
//   };
//   if(!ImagesContent || ImagesContent.length === 0) return null;

//   const validImage = ImagesContent.filter(hasValidContent);
//   if(validImage.length ===0)return null;

//   return (
//     <div>
//       {ImagesContent && ImagesContent.length > 0 && (
//         <div className={`pt-5 pb-5 pl-3 pr-3  ${divstyle}  `}>
//           {/* About */}
//           <div className="pb-2">
//             <h1
//               className={`${LanguageSelected == 'ar'
//                   ? 'title title--h1 first-title title__separate text-theme right-2.5'
//                   : 'title left-2.5 title--h1 first-title title__separate text-theme'
//                 }`}
//             >
//               {t("Portfolio")}
//             </h1>
//           </div>
//           {/* Gally */}
//           <div className="pb-0">
//             <div className="grid  grid-cols-1 js-masonry js-filter-container">
//               <div className="gutter-sizer" />

//               <div className="relative col-12">
//                 <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 z-50 flex gap-2">
//                   {ImagesContent.map((_, i) => (
//                     <span
//                       key={i}
//                       className={`block h-1 mt-2 cursor-pointer rounded-2xl transition-all content-[''] ${currentIndex === i ? 'bg-gray-300 w-8' : 'bg-gray-300 w-4'
//                         }`}
//                       onClick={() => setCurrentIndex(i)}
//                     />
//                   ))}
//                 </div>
//                 <div className="carousel-container relative">
//                   <div className="carousel-wrapper">
//                     {ImagesContent.map((image, index) => (
//                       <figure
//                         key={index}
//                         className={` category-concept pl-3 pr-3 ${currentIndex === index ? '' : 'hidden'}`}
//                       >
//                         <div className="gallery-grid__portfolio-wrap">
//                           <img
//                             className="gallery-grid__portfolio cover lazyload"
//                             src={`${ImageUrl}/${hashedUserId}/${image.image}`}
//                             data-zoom
//                             alt
//                           />
//                         </div>
//                         <figcaption className="gallery-grid__caption mb-2">
//                           <h4 className="title gallery-grid__title text-theme">{image.title}</h4>
//                           <span className=" text-about text-theme">{image.subtitle}</span>
//                         </figcaption>
//                       </figure>
//                     ))}
//                   </div>
//                   {ImagesContent != '' && (
//                     <>
//                       <a
//                         className={`text-gray-300 cursor-pointer absolute -left-4 ml-0.5 next-icon-image hover:text-gray-500`}
//                         onClick={goToPrev}
//                       >
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                           stroke-width="1.5"
//                           stroke="currentColor"
//                           className="w-6 h-6 cursor-pointer text-gray-300"
//                         >
//                           <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
//                         </svg>
//                       </a>
//                       <a
//                         className="text-gray-300 cursor-pointer absolute  -right-4 mr-0.5  absolute next-icon-image hover:text-gray-500"
//                         onClick={goToNext}
//                       >
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                           stroke-width="1.5"
//                           stroke="currentColor"
//                           className="w-6 h-6 cursor-pointer text-gray-300"
//                         >
//                           <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
//                         </svg>
//                       </a>
//                     </>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default Images;

import React from 'react';

function Images({
  ImagesContent,
  LanguageSelected,
  t,
  currentIndex,
  setCurrentIndex,
  ImageUrl,
  hashedUserId,
  goToPrev,
  goToNext,
  divstyle,
  img5
}) {
  // Helper to get language-specific text
  const getText = (textObj) => {
    if (!textObj) return '';
    if (typeof textObj === 'object' && textObj !== null) {
      return textObj[LanguageSelected] || '';
    }
    return textObj || '';
  };

  // Check valid content
  const hasValidContent = (image) => {
    const title = getText(image.title);
    const subtitle = getText(image.subtitle);
    return title.trim() !== '' || subtitle.trim() !== '';
  };

  if (!ImagesContent || ImagesContent.length === 0) return null;

  const validImages = ImagesContent.filter(hasValidContent);
  if (validImages.length === 0) return null;

  return (
    <div>
      <div className={`pt-5 pb-5 pl-3 pr-3 ${divstyle}`}>
        {/* About */}
        <div className="pb-2">
          <h1
            className={`${
              LanguageSelected === 'ar'
                ? 'title title--h1 first-title title__separate text-theme right-2.5'
                : 'title left-2.5 title--h1 first-title title__separate text-theme'
            }`}
          >
            {t("Portfolio")}
          </h1>
        </div>
        
        {/* Gallery */}
        <div className="pb-0">
          <div className="grid grid-cols-1 js-masonry js-filter-container">
            <div className="gutter-sizer" />

            <div className="relative col-12">
              <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 z-50 flex gap-2">
                {validImages.map((_, i) => (
                  <span
                    key={i}
                    className={`block h-1 mt-2 cursor-pointer rounded-2xl transition-all content-[''] ${
                      currentIndex === i ? 'bg-gray-300 w-8' : 'bg-gray-300 w-4'
                    }`}
                    onClick={() => setCurrentIndex(i)}
                  />
                ))}
              </div>
              
              <div className="carousel-container relative">
                <div className="carousel-wrapper">
                  {validImages.map((image, index) => {
                    const imageTitle = getText(image.title);
                    const imageSubtitle = getText(image.subtitle);

                    return (
                      <figure
                        key={image.id || index}
                        className={`category-concept pl-3 pr-3 ${currentIndex === index ? '' : 'hidden'}`}
                      >
                        <div className="gallery-grid__portfolio-wrap">
                          <img
                            className="gallery-grid__portfolio cover lazyload"
                            src={`${ImageUrl}/${hashedUserId}/${image.image}`}
                            data-zoom
                            alt={imageTitle || 'Portfolio image'}
                          />
                        </div>
                        <figcaption className="gallery-grid__caption mb-2">
                          <h4 
                            className={`title gallery-grid__title text-theme ${
                              LanguageSelected === 'ar' ? 'text-right' : 'text-left'
                            }`}
                            dir={LanguageSelected === 'ar' ? 'rtl' : 'ltr'}
                          >
                            {imageTitle || t('Untitled')}
                          </h4>
                          <span 
                            className={`text-about text-theme ${
                              LanguageSelected === 'ar' ? 'text-right' : 'text-left'
                            }`}
                            dir={LanguageSelected === 'ar' ? 'rtl' : 'ltr'}
                          >
                            {imageSubtitle}
                          </span>
                        </figcaption>
                      </figure>
                    );
                  })}
                </div>
                
                {validImages.length > 1 && (
                  <>
                    <a
                      className="text-gray-300 cursor-pointer absolute -left-4 ml-0.5 next-icon-image hover:text-gray-500"
                      onClick={goToPrev}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="w-6 h-6 cursor-pointer text-gray-300"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                      </svg>
                    </a>
                    <a
                      className="text-gray-300 cursor-pointer absolute -right-4 mr-0.5 next-icon-image hover:text-gray-500"
                      onClick={goToNext}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="w-6 h-6 cursor-pointer text-gray-300"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                      </svg>
                    </a>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Images;